const { _createCustomer, _plans, _createCheckoutSession } = require('./../axios');

export const saveCustomer = async () => {

    const userLang = navigator.language || navigator.userLanguage;
    
    
    const customers = [
        {
            "name": `${document.getElementById('contactFirstName').value} ${document.getElementById('contactLastName').value}`,
            "email": document.getElementById('contactEmailAddress').value,
            "phone": document.getElementById('contactPhone').value,
            "shippingAddress": {
                "line1": document.getElementById('shippingAddressLine1').value,
                "line2": document.getElementById('shippingAddressLine2').value,
                "city": document.getElementById('shippingCity').value,
                "country": document.getElementById('shippingCountry').value,
                "postal_code": document.getElementById('shippingPostalCode').value,
                "state": document.getElementById('shippingState').value,
            },
            "billingAddress": {
                "line1": document.getElementById('billingAddressLine1').value,
                "line2": document.getElementById('billingAddressLine2').value,
                "city": document.getElementById('billingCity').value,
                "country": document.getElementById('billingCountry').value,
                "postal_code": document.getElementById('billingPostalCode').value,
                "state": document.getElementById('billingState').value,
            },
            "preferred_locales": userLang,
            "language": document.getElementById('contactLanguage').value,
            "anyVehicleNeedCutOffDevice": document.getElementById('fuelCutOfDevice').checked,
            "nonCarsWillUseTrackers": document.getElementById('bikeTruckOrMachinery').checked,
            "needToIdentifyDrivers": document.getElementById('identifyFleetDrivers').checked
        },
    ];
    const quantity = document.getElementById('howManyTracker').value;

        try {
            if(customers[0].language === '') { customers[0].language = 'en'; }
            const responseCreateCustomer = await _createCustomer(customers);
            if(responseCreateCustomer.status === 200) {
                const responsePlans = await _plans();
                const plan = responsePlans.data.data.filter(x => x.id === 'plan_FnZvsb1CB991jP')[0];
                const checkOut = 
                {
                    cancelUrl: `${window.location.protocol}//${window.location.hostname}/error`,
                    successUrl: `${window.location.protocol}//${window.location.hostname}/success`,
                    customerId: responseCreateCustomer.data.id,
                    customerEmail: responseCreateCustomer.data.email,
                    locale: customers[0].language.split('-')[0],
                    items: 
                        [{
                            id: plan.id,
                            currency: plan.currency,
                            name: plan.nickname,
                            amount: plan.amount,
                            quantity: parseInt(quantity)
                        }]
                };
                const session = await _createCheckoutSession(checkOut);
                return session;
            }
        } catch (error) {
            console.log(error);
            return error;
        }    
};